import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
var DeviceLocationView = /** @class */ (function (_super) {
    tslib_1.__extends(DeviceLocationView, _super);
    function DeviceLocationView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // date: string = null;
        _this.position = null;
        _this.positionDate = "";
        _this.positionFeature = "";
        return _this;
    }
    Object.defineProperty(DeviceLocationView.prototype, "mapRef", {
        get: function () {
            return this.$refs.map;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceLocationView.prototype, "mapPosition", {
        get: function () {
            return this.position ? { lat: this.position.latitude, lng: this.position.longitude } : { lat: 0, lng: 0 };
        },
        enumerable: true,
        configurable: true
    });
    DeviceLocationView.prototype.mounted = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.getLocation(0);
                return [2 /*return*/];
            });
        });
    };
    DeviceLocationView.prototype.getLocation = function (newMode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var newPositionDate, _a, map;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        newPositionDate = this.position ? this.position.timestamp : "";
                        this.positionFeature = "";
                        _a = this;
                        return [4 /*yield*/, axios.get("devices/position", { params: { serialNumber: this.device.serial, positionDate: newPositionDate, mode: newMode } })];
                    case 1:
                        _a.position = (_b.sent()).data;
                        if (this.position) {
                            this.positionDate = this.position.timestamp;
                            this.position.timestamp = new Date(this.position.timestamp).toLocaleDateString().split('T')[0];
                            if (this.position.previous)
                                this.position.previous = new Date(this.position.previous).toLocaleDateString().split('T')[0];
                            if (this.position.next)
                                this.position.next = new Date(this.position.next).toLocaleDateString().split('T')[0];
                            if (this.position.feature == "Service")
                                this.positionFeature = " - " + this.$t("deviceLocationView.service");
                            if (this.position.feature == "Sensor")
                                this.positionFeature = " - " + this.$t("deviceLocationView.sensor");
                        }
                        return [4 /*yield*/, this.mapRef.$mapPromise];
                    case 2:
                        map = _b.sent();
                        google.maps.event.trigger(map, "resize");
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        Prop({ type: Object }),
        tslib_1.__metadata("design:type", Object)
    ], DeviceLocationView.prototype, "device", void 0);
    DeviceLocationView = tslib_1.__decorate([
        Component
    ], DeviceLocationView);
    return DeviceLocationView;
}(Vue));
export default DeviceLocationView;
